import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { AdminActions, ProjectsActions } from 'redux/actions';
import { Layout } from 'components';
import {
  Row,
  Col,
  Input,
  Form,
  Radio,
  Select,
  Spin,
  Button,
  Card,
  DatePicker,
} from 'antd';
import { Container, H1, H2, Modal, PrimaryButton, device, Colors } from 'utils';
// import { Link } from 'react-router-dom';
import styled from '@emotion/styled';
import moment from 'moment';
import ProjectFAQs from './ProjectFAQs';
import { UploadImage } from 'components';
import '../ProjectForm/components/RichTextCss.css';
import '../Project/components/project_details.css';
import ContactModal from 'scenes/Project/components/ContactModal';
import { adminServices } from 'services';
import AvatarBox from 'scenes/Project/v2/components/DetailComponents/AvatarBox';
import RichText from 'scenes/ProjectFormV2/components/RichText';
import DOMPurify from 'dompurify';

const Option = Select.Option;
const FormItem = Form.Item;
const ADMIN_DATE_FORMAT = 'DD.MM.YYYY';

const parseAdminDate = (value) => {
  if (!value) return null;

  const numericValue = Number(value);
  if (Number.isFinite(numericValue)) return moment.unix(numericValue);

  const parsedValue = moment(value);
  return parsedValue.isValid() ? parsedValue : null;
};

const appendEventDates = (formData, values, project) => {
  const hasEventDateFields =
    Object.prototype.hasOwnProperty.call(values, 'event_date') &&
    Object.prototype.hasOwnProperty.call(values, 'funding_end_date');

  if (!project.is_ticketable || !hasEventDateFields) return;

  const eventDate = moment(values.event_date).startOf('day');
  const bookingEndDate = moment(values.funding_end_date).endOf('day');
  const projectStartDate =
    parseAdminDate(project.funding_start_date) ||
    parseAdminDate(project.created_at) ||
    moment();

  formData.append('event_date', eventDate.unix());
  formData.append('funding_end_date', bookingEndDate.unix());
  formData.append(
    'funding_days',
    Math.max(
      bookingEndDate.diff(projectStartDate.startOf('day'), 'days'),
      1
    )
  );
};

const eventDateRules = [
  {
    required: true,
    message: 'Veranstaltungsdatum ist erforderlich',
  },
];

const bookingEndDateRules = [
  {
    required: true,
    message: 'Buchungsschluss ist erforderlich',
  },
  ({ getFieldValue }) => ({
    validator(_, value) {
      const eventDate = getFieldValue('event_date');

      if (!value || !eventDate || !value.isAfter(eventDate, 'day')) {
        return Promise.resolve();
      }

      return Promise.reject(
        new Error(
          'Der Buchungsschluss darf nicht nach dem Veranstaltungsdatum liegen.'
        )
      );
    },
  }),
];
const TableWrapper = styled.div`
  padding: 50px 0;
  h3,
  p {
    margin: 0;
  }
  h2 {
    margin-top: 50px;
    margin-bottom: 10px;
  }
  .ant-row {
    align-items: center;
  }
  .html-content-row {
    align-items: flex-start;
  }
`;

const AdminHtmlContent = styled.div`
  width: 100%;
  font-size: 16px;
  line-height: 24px;
  color: #262626;
  overflow-wrap: anywhere;

  p {
    margin: 0 0 12px;
  }

  p:last-child {
    margin-bottom: 0;
  }
`;

const AdminEditForm = styled(Form)`
  .editor {
    max-height: 240px;
    overflow-y: auto !important;
  }
`;


const PreviewAvatar = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 9999px;
  background: ${({ $bg }) => $bg || '#f5f5f5'};
  border: 1px solid rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  flex: none;
  // margin-right: 16px
`;
const AvatarInner = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 9999px;
  color: ${({ $color }) => $color};
`;

const ActionsWrapper = styled.div`
  display: flex;
  button {
    margin-right: 20px;
  }
  .warning {
    background: #f44336;
    border: 1px solid #f44336;
    &:hover {
      background: ${Colors.transparent};
      border: 1px solid #f44336;
      color: #f44336;
    }
  }
`;

const ModalWrapper = styled.div`
  max-height: 80vh;
  wight: 960px;
  .images {
    overflow-y: scroll;
    max-height: 200px;
    display: flex;
    flex-wrap: wrap;
    margin-top: 15px;
    align-items: center;
    img {
      width: 100px;
      height: auto;
      margin-right: 15px;
      cursor: pointer;
      margin-top: 10px;
      @media ${device.allMobile} {
        width: 28%;
      }
    }
  }
  .selected-image {
    width: 100%;
    height: 550px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    @media ${device.allMobile} {
      height: auto;
    }
    img {
      width: 100%;
      height: auto;
      max-height: 550px;
      object-fit: cover;
    }
  }
`;

export class ViewProject extends Component {
  editFormRef = React.createRef();
  startFormRef = React.createRef();

  static propTypes = {
    project: PropTypes.object.isRequired,
    showProjectById: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    declineProject: PropTypes.func.isRequired,
    acceptProject: PropTypes.func.isRequired,
    updateProject: PropTypes.func.isRequired,
    startAgainProject: PropTypes.func.isRequired,
    getProjectCategories: PropTypes.func.isRequired,
    categories: PropTypes.array.isRequired,
    deleteFile: PropTypes.func.isRequired,
  };
  componentDidMount() {
    const {
      showProjectById,
      getProjectCategories,
      match: {
        params: { id },
      },
    } = this.props;
    showProjectById(id);
    getProjectCategories();
    this.fetchPromotions();
  }

  setEditRichTextContent = (content, name) => {
    this.editFormRef.current?.setFieldsValue({ [name]: content });
  };

  setStartRichTextContent = (content, name) => {
    this.startFormRef.current?.setFieldsValue({ [name]: content });
  };

  fetchPromotions = async () => {
    try {
      const promotions = await adminServices.getPromotionItems();
      this.setState({ promotions: promotions || [] });
    } catch (error) {
      console.error('Error fetching promotions:', error);
    }
  };

  componentDidUpdate(prevProps) {
    // When project is loaded, filter selected promotions
    if (prevProps.project !== this.props.project && this.props.project?.selected_promotion_ids) {
      const { promotions } = this.state;
      const selectedIds = this.props.project.selected_promotion_ids;
      const selectedPromotions = promotions.filter(p => selectedIds.includes(p.id));
      this.setState({ selectedPromotions });
    }
    // Also update when promotions are loaded
    if (this.state.promotions.length > 0 && this.state.selectedPromotions.length === 0 && this.props.project?.selected_promotion_ids?.length > 0) {
      const selectedIds = this.props.project.selected_promotion_ids;
      const selectedPromotions = this.state.promotions.filter(p => selectedIds.includes(p.id));
      if (selectedPromotions.length > 0) {
        this.setState({ selectedPromotions });
      }
    }
  }
  handleChange = (value) => {
    this.setState({ value });
  };

  state = {
    showModal: false,
    selectedImage: this.props.project.images && this.props.project.images[0],
    showImageModal: false,
    showEditModal: false,
    showStartModal: false,
    totalDecline: false,
    selectedField: '',
    selectedImages: {
      banner: '',
      outer: '',
    },
    bannerImage: null,
    outerImage: null,
    images: null,
    showDonationsEditModal: false,
    value: [],
    defValue: ['project1', 'project 2'],
    showConfirmDeleteFileModal: false,
    fileToDelete: null,
    promotions: [],
    selectedPromotions: [],

    // selectedMuliple: []
  };

  // imageChangehandler = (event, type) => {
  //   if (type == "banner") {
  //     this.setState(prevState => ({
  //       selectedImages: {
  //         ...prevState.selectedImages,
  //         banner: event.target.files[0]
  //       }
  //     }))
  //   }
  //   if (type == "outer") {
  //     this.setState(prevState => ({
  //       selectedImages: {
  //         ...prevState.selectedImages,
  //         outer: event.target.files[0]
  //       }
  //     }))
  //   }
  // };
  setBannerImage = (image) => this.setState({ bannerImage: image });
  setOuterImage = (image) => this.setState({ outerImage: image });
  setImages = (image) => this.setState({ images: image });

  handelCloseModal = () => {
    this.setState({ showModal: false, showImageModal: false });
    document.body.style.overflowY = 'unset';
  };
  handelCloseEditModal = () => {
    this.setState({ showEditModal: false });
    document.body.style.overflowY = 'unset';
  };
  handelCloseStartModal = () => {
    this.setState({ showStartModal: false });
    document.body.style.overflowY = 'unset';
  };
  handleSelectedImage = (selectedImage) => {
    this.setState({ selectedImage });
  };
  handelCloseConfirmDeleteFileModal = () => {
    this.setState({ fileToDelete: null, showConfirmDeleteFileModal: false });
    document.body.style.overflowY = 'unset';
  };
  handelShowModal = () => {
    this.setState({ showModal: true });
    document.body.style.overflowY = 'hidden';
  };

  handelEditModal = () => {
    this.setState({ showEditModal: true });
    document.body.style.overflowY = 'hidden';
  };
  handelStartModal = () => {
    this.setState({ showStartModal: true });
    document.body.style.overflowY = 'hidden';
  };

  handelShowConfirmDeleteFileModal = (id) => {
    this.setState({ fileToDelete: id, showConfirmDeleteFileModal: true });
    document.body.style.overflowY = 'hidden';
  };

  handelShowImagesModal = () => {
    this.setState({ showImageModal: true });
    document.body.style.overflowY = 'hidden';
  };

  handelEditDonationsModal = () => {
    this.setState({ showDonationsEditModal: true });
    // document.body.style.overflowY = 'hidden';
  };

  handelCloseEditDonationsModal = () => {
    this.setState({ showDonationsEditModal: false });
    // document.body.style.overflowY = 'hidden';
  };

  onFinish = (values) => {
    const { totalDecline } = this.state;
    const {
      declineProject,
      match: {
        params: { id },
      },
    } = this.props;

    if (totalDecline) {
      declineProject(id, '');
    } else {
      declineProject(id, values.message);
    }
    this.handelCloseModal();
  };

  onEdit = (values) => {
    const {
      updateProject,
      showProjectById,
      project,
      match: {
        params: { id },
      },
    } = this.props;
    const { bannerImage, outerImage, images } = this.state;

    const faq = [
      values.projekt,
      values.zielgruppe,
      project.is_ticketable ? project.faq?.[2] || '' : values.unterstützen,
      project.is_ticketable ? project.faq?.[3] || '' : values.finanzierung,
      values.hinter,
    ];

    const formData = new FormData();
    Object.keys(values).forEach((key) => {
      if (key === 'event_date' || key === 'funding_end_date') return;
      if (values[key] || key === 'paypal_check') {
        formData.append(key, values[key]);
      }
    });
    appendEventDates(formData, values, project);

    if (bannerImage && bannerImage[0].thumbUrl) {
      formData.append('banner', bannerImage[0].originFileObj);
    }

    if (outerImage && outerImage[0].thumbUrl) {
      formData.append('outer_image', outerImage[0].originFileObj);
    }

    if (images) {
      const imgArr = images?.filter((img) => img.thumbUrl);
      imgArr.forEach((file) => {
        formData.append('images[]', file.originFileObj);
      });
    }
    formData.append('pay_out', values.pay_out);

    const hasFaqFields = ['projekt', 'zielgruppe', 'hinter'].some((field) =>
      Object.prototype.hasOwnProperty.call(values, field)
    );

    if (hasFaqFields) {
      faq.forEach((item) => formData.append('faq[]', item || ''));
    }

    if (values.is_ticketable) {
      formData.append('is_ticketable', true);
      formData.append('is_patreon', false);
    } else if (values.is_ticketable === null) {
      formData.append('is_ticketable', false);
      formData.append('is_patreon', false);
    } else if (values.is_ticketable === false) {
      formData.append('is_ticketable', false);
      formData.append('is_patreon', true);
    }

    updateProject(id, formData);
    this.handelCloseEditModal();
    this.handelCloseEditDonationsModal();
    setTimeout(() => {
      showProjectById(id);
    }, 3000);
  };

  onStart = (values) => {
    const {
      startAgainProject,
      showProjectById,
      project,
      match: {
        params: { id },
      },
    } = this.props;
    const { bannerImage, outerImage, images } = this.state;

    const faq = [
      values.projekt,
      values.zielgruppe,
      project.is_ticketable ? project.faq?.[2] || '' : values.unterstützen,
      project.is_ticketable ? project.faq?.[3] || '' : values.finanzierung,
      values.hinter,
    ];

    const formData = new FormData();
    Object.keys(values).forEach((key) => {
      if (key === 'event_date' || key === 'funding_end_date') return;
      if (values[key] || key === 'paypal_check') {
        formData.append(key, values[key]);
      }
    });
    appendEventDates(formData, values, project);

    if (bannerImage && bannerImage[0].thumbUrl) {
      formData.append('banner', bannerImage[0].originFileObj);
    }

    if (outerImage && outerImage[0].thumbUrl) {
      formData.append('outer_image', outerImage[0].originFileObj);
    }

    if (images) {
      const imgArr = images?.filter((img) => img.thumbUrl);
      imgArr.forEach((file) => {
        formData.append('images[]', file.originFileObj);
      });
    }

    faq.forEach((item) => formData.append('faq[]', item || ''));
    formData.append('status', 'accepted');
    startAgainProject(id, formData);
    this.handelCloseStartModal();
    this.handelCloseEditDonationsModal();
    setTimeout(() => {
      showProjectById(id);
    }, 3000);
  };

  onDeleteFile = () => {
    const { fileToDelete } = this.state;
    const {
      deleteFile,
      match: {
        params: { id },
      },
    } = this.props;

    if (id && fileToDelete) {
      deleteFile(id, fileToDelete);
    }
    this.handelCloseConfirmDeleteFileModal();
  };

  render() {
    const {
      project,
      match: {
        params: { id },
      },
      acceptProject,
    } = this.props;
    const {
      showModal,
      selectedImage,
      showImageModal,
      totalDecline,
      showEditModal,
      showStartModal,
      showDonationsEditModal,
      showConfirmDeleteFileModal,
    } = this.state;
    const { value } = this.state;
    const {
      categories,
      loading,
      hideProject,
      closeJob,
      recurringJob,
      checkMark,
      projectPaypalToggleHandler,
      projectToggleAnonymousHandler
    } = this.props;

    return (
      <>
        <ContactModal />
        <Layout>
          <Container>
            <TableWrapper>
              <H1>View project</H1>
              <ActionsWrapper>
                <PrimaryButton
                  style={{ fontSize: 18 }}
                  minWidth={
                    project?.status === 'accepted'
                      ? '15%'
                      : project?.status === 'finished' ||
                        project?.status === 'successful'
                      ? '18%'
                      : '20%'
                  }
                  primary={false}
                  onClick={() => acceptProject(id)}
                >
                  Accept
                </PrimaryButton>
                <PrimaryButton
                  style={{ fontSize: 18 }}
                  minWidth={
                    project?.status === 'accepted'
                      ? '15%'
                      : project?.status === 'finished' ||
                        project?.status === 'successful'
                      ? '18%'
                      : '20%'
                  }
                  primary={true}
                  onClick={() => this.handelShowModal()}
                >
                  Decline
                </PrimaryButton>
                <PrimaryButton
                  style={{ fontSize: 18 }}
                  minWidth={
                    project?.status === 'accepted'
                      ? '15%'
                      : project?.status === 'finished' ||
                        project?.status === 'successful'
                      ? '18%'
                      : '20%'
                  }
                  onClick={() => {
                    this.setState({ totalDecline: true });
                    this.handelShowModal();
                  }}
                  className="warning"
                >
                  Total Decline
                </PrimaryButton>
                <PrimaryButton
                  style={{ fontSize: 18 }}
                  minWidth={
                    project?.status === 'accepted'
                      ? '15%'
                      : project?.status === 'finished' ||
                        project?.status === 'successful'
                      ? '18%'
                      : '20%'
                  }
                  primary={false}
                  onClick={() => {
                    this.handelEditModal();
                  }}
                >
                  Edit
                </PrimaryButton>
                {(project?.status === 'finished' ||
                  project?.status === 'successful' ||
                  project?.status === 'accepted') && (
                  <PrimaryButton
                    style={{ fontSize: 18 }}
                    minWidth={'15%'}
                    primary={false}
                    onClick={() => {
                      this.handelEditDonationsModal();
                    }}
                  >
                    Edit Donations Sum
                  </PrimaryButton>
                )}
              </ActionsWrapper>
              <ActionsWrapper>
                {(project?.status === 'finished' ||
                  project?.status === 'successful') && (
                  <PrimaryButton
                    style={{ fontSize: 18 }}
                    minWidth={'18%'}
                    primary={false}
                    onClick={() => {
                      this.handelStartModal();
                    }}
                  >
                    Start Again
                  </PrimaryButton>
                )}
                <PrimaryButton
                  style={{ fontSize: 18 }}
                  minWidth={'18%'}
                  onClick={() =>
                    hideProject({ id, visible: !project?.visible })
                  }
                >
                  {project?.visible ? 'Hide' : 'Unhide'}
                </PrimaryButton>

                <PrimaryButton
                  style={{ fontSize: 18 }}
                  minWidth={'18%'}
                  onClick={() => closeJob({ id })}
                >
                  Auto funding Days Close
                </PrimaryButton>
                <PrimaryButton
                  style={{ fontSize: 18 }}
                  minWidth={'18%'}
                  onClick={() =>
                    recurringJob({
                      id,
                      recurring_check: !project?.recurring_check,
                    })
                  }
                >
                  {project?.recurring_check
                    ? 'Disable Recurring'
                    : 'Enable Recurring'}
                </PrimaryButton>

                <PrimaryButton
                  style={{ fontSize: 18 }}
                  minWidth={'18%'}
                  onClick={() =>
                    projectPaypalToggleHandler({
                      id,
                      project_paypal_toggle: !project?.paypal_check,
                    })
                  }
                >
                  {project?.paypal_check ? 'Disable Pyapal' : 'Enable Pyapal'}
                </PrimaryButton>
                <PrimaryButton
                  style={{ fontSize: 18 }}
                  minWidth={'18%'}
                  onClick={() =>
                    projectPaypalToggleHandler({
                      id,
                      anonymous_status: !project?.anonymous_status,
                      visible: !project?.anonymous_status,
                    })
                  }
                >
                  {project?.anonymous_status
                    ? 'Disable Anonymous'
                    : 'Enable Anonymous'}
                </PrimaryButton>
              </ActionsWrapper>
              <ActionsWrapper>
                <PrimaryButton
                  style={{ fontSize: 18 }}
                  minWidth={'18%'}
                  onClick={() =>
                    projectToggleAnonymousHandler({
                      id,
                      enable_email_anonymous: !project?.enable_email_anonymous,
                      visible: !project?.enable_email_anonymous,
                    })
                  }
                >
                  {project?.enable_email_anonymous
                    ? 'Hide donation emails'
                    : 'Show donation emails'}
                </PrimaryButton>
                <PrimaryButton
                  style={{ fontSize: 18 }}
                  minWidth={'18%'}
                  onClick={() =>
                    checkMark({
                      id,
                      checkmark_enabled: !project?.checkmark_enabled,
                    })
                  }
                >
                  {project?.checkmark_enabled
                    ? 'Disable Checkmark'
                    : 'Enable Checkmark'}
                </PrimaryButton>
              </ActionsWrapper>
              {project && (
                <>
                  <H2>Project Status</H2>
                  <Row>
                    <Col span={6}>
                      <h3>Status:</h3>
                    </Col>
                    <Col span={18}>
                      <p>{project.status}</p>
                    </Col>
                  </Row>
                  <H2>Project Details</H2>
                  <Row>
                    <Col span={6}>
                      <h3>Title:</h3>
                    </Col>
                    <Col span={18}>
                      <p>{project.title}</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={6}>
                      <h3>SubTile:</h3>
                    </Col>
                    <Col span={18}>
                      <p>{project.subtitle}</p>
                    </Col>
                  </Row>
                  <Row className="html-content-row">
                    <Col span={6}>
                      <h3>Description:</h3>
                    </Col>
                    <Col span={18}>
                      <AdminHtmlContent
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(
                            project.description || '',
                            {
                              ALLOWED_TAGS: [
                                'b',
                                'strong',
                                'i',
                                'em',
                                'u',
                                'p',
                                'br',
                                'ul',
                                'ol',
                                'li',
                                'a',
                              ],
                              ALLOWED_ATTR: ['href', 'target', 'rel'],
                            }
                          ),
                        }}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col span={6}>
                      <h3>URL:</h3>
                    </Col>
                    <Col span={18}>
                      <p>{project.url}</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={6}>
                      <h3>City:</h3>
                    </Col>
                    <Col span={18}>
                      <p>{project.city}</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={6}>
                      <h3>Tags</h3>
                    </Col>
                    <Col span={18}>
                      <p>
                        {project.tags && project.tags?.map((tag) => `${tag}, `)}
                      </p>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={6}>
                      <h3>Project Type</h3>
                    </Col>
                    <Col span={18}>
                      <p>{project.project_type}</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={6}>
                      <h3>Account Holder</h3>
                    </Col>
                    <Col span={18}>
                      <p>{project.account_holder}</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={6}>
                      <h3>Message</h3>
                    </Col>
                    <Col span={18}>
                      <p>{project.message}</p>
                    </Col>
                  </Row>
                  <H2>Images And Video</H2>
                  <Row>
                    <Col span={6}>
                      <h3>Video</h3>
                    </Col>
                    <Col span={18}>
                      {project.video && (
                        <a
                          href={project.video}
                          rel="noreferrer"
                          target="_blank"
                        >
                          Link
                        </a>
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col span={6}>
                      <h3>Banner</h3>
                    </Col>
                    <Col span={18}>
                      {project.banner && (
                        <a
                          href={project.banner}
                          rel="noreferrer"
                          target="_blank"
                        >
                          Link
                        </a>
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col span={6}>
                      <h3>Outer Image</h3>
                    </Col>
                    <Col span={18}>
                      {project.outer_image && (
                        <a
                          href={project.outer_image}
                          rel="noreferrer"
                          target="_blank"
                        >
                          Link
                        </a>
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col span={6}>
                      <h3>Images</h3>
                    </Col>
                    <Col span={18}>
                      {project.images && project.images.length > 0 && (
                        <a
                          href="#!"
                          onClick={() => this.handelShowImagesModal()}
                        >
                          View Images
                        </a>
                      )}
                    </Col>
                  </Row>
                  <H2>Foundation Details</H2>
                  <Row>
                    <Col span={6}>
                      <h3>Funding days</h3>
                    </Col>
                    <Col span={18}>
                      <p>{project.funding_days} Tage</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={6}>
                      <h3>Goal</h3>
                    </Col>
                    <Col span={18}>
                      <p>{project.goal} €</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={6}>
                      <h3>Final Goal</h3>
                    </Col>
                    <Col span={18}>
                      <p>{project.final_goal} €</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={6}>
                      <h3>Goal Explanation</h3>
                    </Col>
                    <Col span={18}>
                      <p>{project.goal_explanation}</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={6}>
                      <h3>Funding Start Date</h3>
                    </Col>
                    <Col span={18}>
                      <p>
                        {project.funding_start_date &&
                          moment.unix(project.funding_start_date).format(
                            ADMIN_DATE_FORMAT
                          )}
                      </p>
                    </Col>
                  </Row>
                  {project.is_ticketable && (
                    <Row>
                      <Col span={6}>
                        <h3>Veranstaltungsdatum</h3>
                      </Col>
                      <Col span={18}>
                        <p>
                          {project.event_date
                            ? moment
                                .unix(project.event_date)
                                .format(ADMIN_DATE_FORMAT)
                            : '—'}
                        </p>
                      </Col>
                    </Row>
                  )}
                  <Row>
                    <Col span={6}>
                      <h3>
                        {project.is_ticketable
                          ? 'Buchungsschluss'
                          : 'Funding End Date'}
                      </h3>
                    </Col>
                    <Col span={18}>
                      <p>
                        {project.funding_end_date &&
                          moment.unix(project.funding_end_date).format(
                            ADMIN_DATE_FORMAT
                          )}
                      </p>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={6}>
                      <h3>Donation Receipts Possible</h3>
                    </Col>
                    <Col span={18}>
                      <p>
                        {project.donation_receipts_possible &&
                          project.donation_receipts_possible.toString()}
                      </p>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={6}>
                      <h3>Donations Count</h3>
                    </Col>
                    <Col span={18}>
                      <p>{project.donations_count}</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={6}>
                      <h3>Donations Sum</h3>
                    </Col>
                    <Col span={18}>
                      <p>{project.donations_sum}</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={6}>
                      <h3>Bill Possible</h3>
                    </Col>
                    <Col span={18}>
                      <p>
                        {project.bill_possible &&
                          project.bill_possible.toString()}
                      </p>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={6}>
                      <h3>PayPal status</h3>
                    </Col>
                    <Col span={18}>
                      <p>{project?.paypal_check?.toString()}</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={6}>
                      <h3>PayPal Email</h3>
                    </Col>
                    <Col span={18}>
                      <p>{project.paypal_email && project.paypal_email}</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={6}>
                      <h3>Über commonsplace erfahren durch</h3>
                    </Col>
                    <Col span={18}>
                      <p>{project.learned_about && project.learned_about}</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={6}>
                      <h3>Ticket machen</h3>
                    </Col>
                    <Col span={18}>
                      <p>{project?.is_ticketable?.toString()}</p>
                    </Col>
                  </Row>

                  <H2>
                    {project.business_type === 'individual'
                      ? 'Personalization / Private Initiator'
                      : 'Personalization / Organization'}
                  </H2>

                  {project.business_type === 'individual' ? (
                    <>
                      <Row>
                        <Col span={6}>
                          <h3>Initiator Name</h3>
                        </Col>
                        <Col span={18}>
                          <p>
                            {project.initiator_first_name ||
                            project.initiator_last_name
                              ? `${project.initiator_first_name || ''} ${
                                  project.initiator_last_name || ''
                                }`.trim()
                              : '-'}
                          </p>
                        </Col>
                      </Row>

                      <Row>
                        <Col span={6}>
                          <h3>Visibility</h3>
                        </Col>
                        <Col span={18}>
                          <p>{project.visibility || '-'}</p>
                        </Col>
                      </Row>

                      <Row>
                        <Col span={6}>
                          <h3>Selected Avatar</h3>
                        </Col>
                        <Col span={18}>
                          <p>{project.selected_avatar || '-'}</p>
                        </Col>
                      </Row>

                      <Row>
                        <Col span={6}>
                          <h3>Personalization Done</h3>
                        </Col>
                        <Col span={18}>
                          <p>{project.is_personalization_done?.toString()}</p>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    <>
                      <Row>
                        <Col span={6}>
                          <h3>Organization Name</h3>
                        </Col>
                        <Col span={18}>
                          <p>{project.organization_name || '-'}</p>
                        </Col>
                      </Row>

                      <Row>
                        <Col span={6}>
                          <h3>Organization Type</h3>
                        </Col>
                        <Col span={18}>
                          <p>{project.organization_type || '-'}</p>
                        </Col>
                      </Row>

                      <Row>
                        <Col span={6}>
                          <h3>Organization Logo</h3>
                        </Col>
                        <Col span={18}>
                          {project.organization_logo ? (
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 16,
                              }}
                            >
                              <img
                                src={project.organization_logo}
                                alt="Organization Logo"
                                style={{
                                  width: 80,
                                  height: 80,
                                  objectFit: 'cover',
                                  borderRadius: '50%',
                                  border: '1px solid #e5e5e5',
                                }}
                              />

                              <a
                                href={project.organization_logo}
                                rel="noreferrer"
                                target="_blank"
                              >
                                Link
                              </a>
                            </div>
                          ) : (
                            <p>-</p>
                          )}
                        </Col>
                      </Row>
                    </>
                  )}

                  <H2>Support Levels</H2>

                  <Row>
                    <Col span={6}>
                      <h3>Support Levels Done</h3>
                    </Col>

                    <Col span={18}>
                      <p>{project.is_support_levels_done?.toString()}</p>
                    </Col>
                  </Row>

                  <Row>
                    <Col span={6}>
                      <h3>Hide Ticket Sales Count</h3>
                    </Col>

                    <Col span={18}>
                      <p>{project.hide_ticket_sales_count?.toString()}</p>
                    </Col>
                  </Row>

                  <Row>
                    <Col span={6}>
                      <h3>Support Levels</h3>
                    </Col>

                    <Col span={18}>
                      {project.support_levels?.length > 0 ? (
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 12,
                          }}
                        >
                          {project.support_levels.map((level, index) => (
                            <Card
                              key={`${level.title}-${index}`}
                              style={{
                                background: '#fafafa',

                                border: '1px solid #e5e5e5',

                                borderRadius: 8,
                              }}
                            >
                              <div>
                                <h3 style={{ marginBottom: 4 }}>
                                  {level.price ? `${level.price} €` : '-'}
                                </h3>

                                <p style={{ marginBottom: 4 }}>
                                  <strong>{level.title || '-'}</strong>
                                </p>

                                <p style={{ marginBottom: 0 }}>
                                  {level.description || '-'}
                                </p>

                                <p
                                  style={{
                                    marginTop: 6,
                                    marginBottom: 0,
                                    color: '#717680',
                                  }}
                                >
                                  {Number(level.booked || 0)} mal gebucht
                                </p>
                              </div>
                            </Card>
                          ))}
                        </div>
                      ) : (
                        <p>Keine Support Levels vorhanden</p>
                      )}
                    </Col>
                  </Row>
                  <H2>Initiator</H2>
                  <Row>
                    <Col span={6}>
                      <h3>Vorschau</h3>
                    </Col>
                    <Col span={18}>
                      <AvatarBox project={project} size={40} badgeSize={15} />
                    </Col>
                  </Row>
                  <Row>
                    <Col span={6}>
                      <h3>Name</h3>
                    </Col>
                    <Col span={18}>
                      <p>
                        {project.initiator_first_name}{' '}
                        {project.initiator_last_name}
                      </p>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={6}>
                      <h3>Email</h3>
                    </Col>
                    <Col span={18}>
                      <p>{project.initiator_email}</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={6}>
                      <h3>Nationality</h3>
                    </Col>
                    <Col span={18}>
                      <p>{project.initiator_nationality}</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={6}>
                      <h3>Phone</h3>
                    </Col>
                    <Col span={18}>
                      <p>{project.initiator_phone_number}</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={6}>
                      <h3>City</h3>
                    </Col>
                    <Col span={18}>
                      <p>{project.initiator_city}</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={6}>
                      <h3>Country</h3>
                    </Col>
                    <Col span={18}>
                      <p>{project.initiator_country}</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={6}>
                      <h3>Building Number</h3>
                    </Col>
                    <Col span={18}>
                      <p>{project.initiator_building_number}</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={6}>
                      <h3>Street</h3>
                    </Col>
                    <Col span={18}>
                      <p>{project.initiator_street}</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={6}>
                      <h3>Zip Code</h3>
                    </Col>
                    <Col span={18}>
                      <p>{project.initiator_zip_code}</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={6}>
                      <h3>Birthday</h3>
                    </Col>
                    <Col span={18}>
                      <p>
                        {project.initiator_birthday &&
                          moment(project.initiator_birthday).format('LL')}
                      </p>
                    </Col>
                  </Row>
                  {/* <H2>Bank Account</H2>
                  <Row>
                    <Col span={6}>
                      <h3>IBAN</h3>
                    </Col>
                    <Col span={18}>
                      <p>{project.iban}</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={6}>
                      <h3>BIC</h3>
                    </Col>
                    <Col span={18}>
                      <p>{project.bic}</p>
                    </Col>
                  </Row> */}
                  <H2>Social Media</H2>
                  <Row>
                    <Col span={6}>
                      <h3>FaceBook</h3>
                    </Col>
                    <Col span={18}>
                      {project.facebook_url && (
                        <a
                          href={`${project.facebook_url}`}
                          rel="noreferrer"
                          target="_blank"
                        >
                          Link
                        </a>
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col span={6}>
                      <h3>WebSite</h3>
                    </Col>
                    <Col span={18}>
                      {project.website_url && (
                        <a
                          href={`${project.website_url}`}
                          rel="noreferrer"
                          target="_blank"
                        >
                          Link
                        </a>
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col span={6}>
                      <h3>Instagram</h3>
                    </Col>
                    <Col span={18}>
                      {project.instagram_url && (
                        <a
                          href={`${project.instagram_url}`}
                          rel="noreferrer"
                          target="_blank"
                        >
                          Link
                        </a>
                      )}
                    </Col>
                  </Row>
                  <H2>Stripe</H2>
                  <Row>
                    <Col span={6}>
                      <h3>Connected Account</h3>
                    </Col>
                    <Col span={18}>
                      <p>{project.stripe_connect_id}</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={6}>
                      <h3>Projekte mit dem gleichen Account</h3>
                    </Col>
                    <Col span={18}>
                      <p>
                        {project.shared_stripe_project_ids?.active?.length > 0 &&
                          project.shared_stripe_project_ids.active.join(', ')}
                      </p>
                    </Col>
                  </Row>
                  <H2>Selected Promotion</H2>
                  <Card style={{ marginTop: 24, background: '#fafafa' }}>
                    {this.state.selectedPromotions?.length > 0 ? (
                      <div>
                        {this.state.selectedPromotions.map((promotion) => (
                          <div
                            key={promotion.id}
                            style={{
                              marginBottom: 16,
                              padding: '16px',
                              border: '1px solid #e5e5e5',
                              borderRadius: 8,
                              background: '#fff',
                            }}
                          >
                            <div
                              style={{
                                display: 'flex',
                                gap: '16px',
                                alignItems: 'flex-start',
                              }}
                            >
                              {promotion.image_url && (
                                <img
                                  src={promotion.image_url}
                                  alt={promotion.title}
                                  style={{
                                    width: 120,
                                    height: 80,
                                    objectFit: 'cover',
                                    borderRadius: 8,
                                  }}
                                />
                              )}
                              <div style={{ flex: 1 }}>
                                <h3 style={{ margin: 0, marginBottom: 4 }}>
                                  {promotion.title}
                                </h3>
                                <p
                                  style={{
                                    margin: 0,
                                    color: '#669F2A',
                                    fontWeight: 600,
                                  }}
                                >
                                  {promotion.subtitle}
                                </p>
                                <div
                                  style={{
                                    marginTop: 8,
                                    fontSize: '0.9em',
                                    color: '#666',
                                  }}
                                  dangerouslySetInnerHTML={{
                                    __html: promotion.description,
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : project?.selected_promotion_ids?.length > 0 ? (
                      <div>
                        <h4>Selected Promotion IDs:</h4>
                        <ul>
                          {project.selected_promotion_ids.map((id) => (
                            <li key={id}>ID: {id}</li>
                          ))}
                        </ul>
                      </div>
                    ) : (
                      <h4>Keine Promotions ausgewählt</h4>
                    )}
                  </Card>
                  <H2>Sonstige Dokumente</H2>
                  <Card style={{ marginTop: 24, background: '#fafafa' }}>
                    {project.support_documents?.length > 0 ? (
                      <div style={{ marginTop: 16 }}>
                        <h4>Hochgeladene Dateien</h4>
                        <ul style={{ listStyle: 'none', padding: 0 }}>
                          {project.support_documents.map((file) => (
                            <li
                              key={file.filename}
                              style={{
                                marginBottom: 10,
                                padding: '10px',
                                border: '1px solid #e5e5e5',
                                borderRadius: 4,
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                              }}
                            >
                              <div>
                                <strong>{file.filename}</strong>
                                <div
                                  style={{ fontSize: '0.85em', color: '#888' }}
                                >
                                  {(file.byte_size / 1024).toFixed(1)} KB
                                </div>
                              </div>
                              <div>
                                <Button
                                  type="primary"
                                  ghost
                                  size="small"
                                  onClick={() =>
                                    window.open(file.url, '_blank')
                                  }
                                  style={{ marginRight: '12px' }}
                                >
                                  Download
                                </Button>
                                <Button
                                  type="primary"
                                  ghost
                                  size="small"
                                  onClick={() =>
                                    this.handelShowConfirmDeleteFileModal(
                                      file.id
                                    )
                                  }
                                >
                                  Delete
                                </Button>
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>
                    ) : (
                      <h4>Keine hochgeladenen Dokumente</h4>
                    )}
                  </Card>
                  <H2>FAQ</H2>
                  <ProjectFAQs
                    projectFaq={project.faq}
                    isTicketable={project.is_ticketable}
                  />
                </>
              )}
            </TableWrapper>
          </Container>
        </Layout>
        <Modal showModal={showModal} handelCloseModal={this.handelCloseModal}>
          <Form onFinish={this.onFinish}>
            {totalDecline ? (
              <>
                <FormItem
                  label="Message"
                  name="message"
                  extra={`please input "${project.title}"`}
                  rules={[
                    {
                      required: true,
                    },
                    () => ({
                      validator(_, value) {
                        if (
                          value.replaceAll(' ', '') ===
                          project.title.replaceAll(' ', '')
                        ) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          'Please Input correct project Title'
                        );
                      },
                    }),
                  ]}
                >
                  <Input.TextArea placeholder="Message" />
                </FormItem>
                <FormItem>
                  <PrimaryButton
                    type="primary"
                    htmltype="submit"
                    minWidth="150px"
                  >
                    Submit
                  </PrimaryButton>
                </FormItem>
              </>
            ) : (
              <>
                <FormItem
                  label="Message"
                  name="message"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Input.TextArea placeholder="Message" />
                </FormItem>
                <FormItem>
                  <PrimaryButton
                    type="primary"
                    htmltype="submit"
                    minWidth="150px"
                  >
                    Submit
                  </PrimaryButton>
                </FormItem>
              </>
            )}
          </Form>
        </Modal>
        <Modal
          showModal={showImageModal}
          handelCloseModal={this.handelCloseModal}
        >
          <ModalWrapper>
            <div className="selected-image">
              <img src={selectedImage} alt="selected-project-img" />
            </div>
            <div className="images">
              {project.images &&
                project.images?.map((img, index) => (
                  <img
                    key={index}
                    src={img}
                    alt="project-img"
                    onClick={() => this.handleSelectedImage(img)}
                  />
                ))}
            </div>
          </ModalWrapper>
        </Modal>
        <Modal
          showModal={showDonationsEditModal}
          handelCloseModal={this.handelCloseEditDonationsModal}
        >
          <H2 style={{ textAlign: 'center', marginBottom: '30px' }}>
            Edit Donations Sum
          </H2>
          <Form layout="vertical" onFinish={this.onEdit}>
            <FormItem
              name="donations_sum"
              initialValue={project?.donations_sum}
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input placeholder="Donations Sum" size="large" />
            </FormItem>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: '40px',
              }}
            >
              <PrimaryButton
                type="primary"
                htmltype="submit"
                // minWidth="150px"
              >
                Update
              </PrimaryButton>
            </div>
          </Form>
        </Modal>
        <Modal
          showModal={showEditModal}
          handelCloseModal={this.handelCloseEditModal}
          width="880px"
        >
          <H2>Edit Project</H2>
          <AdminEditForm
            ref={this.editFormRef}
            layout="vertical"
            onFinish={this.onEdit}
          >
            <FormItem label="Title" name="title" initialValue={project.title}>
              <Input placeholder="Title" />
            </FormItem>

            <FormItem
              label="SubTile"
              name="subtitle"
              initialValue={project.subtitle}
            >
              <Input placeholder="SubTile" />
            </FormItem>

            <FormItem
              label="Description"
              name="description"
              initialValue={project.description}
            >
              <RichText
                name="description"
                getContent={this.setEditRichTextContent}
                placeholder="Description"
              />
            </FormItem>

            <FormItem
              name={'projekt'}
              label={
                project.is_ticketable
                  ? 'Was ist der Zweck der Veranstaltung?'
                  : 'Zweck: Was ist der genaue Zweck des Projektes?'
              }
              initialValue={project.faq && project.faq[0]}
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <RichText
                name="projekt"
                getContent={this.setEditRichTextContent}
                placeholder="Antwort eingeben..."
              />
            </FormItem>
            <FormItem
              name={'zielgruppe'}
              label={
                project.is_ticketable
                  ? 'Was sind die Ziele – und wer ist die Zielgruppe?'
                  : 'Ziele und Zielgruppe: Was sind die Ziele und wer ist die Zielgruppe?'
              }
              initialValue={project.faq && project.faq[1]}
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <RichText
                name="zielgruppe"
                getContent={this.setEditRichTextContent}
                placeholder="Antwort eingeben..."
              />
            </FormItem>
            {!project.is_ticketable && (
              <>
                <FormItem
                  name={'unterstützen'}
                  label="Wofür werden die Unterstützungen verwendet?"
                  initialValue={project.faq && project.faq[2]}
                  rules={[
                    {
                      required: false,
                    },
                  ]}
                >
                  <RichText
                    name="unterstützen"
                    getContent={this.setEditRichTextContent}
                    placeholder="Antwort eingeben..."
                  />
                </FormItem>
                <FormItem
                  name={'finanzierung'}
                  label="Wie sorgst du für Transparenz und einen verantwortungsvollen Umgang mit den Unterstützungen?"
                  initialValue={project.faq && project.faq[3]}
                  rules={[
                    {
                      required: false,
                    },
                  ]}
                >
                  <RichText
                    name="finanzierung"
                    getContent={this.setEditRichTextContent}
                    placeholder="Antwort eingeben..."
                  />
                </FormItem>
              </>
            )}
            <FormItem
              name={'hinter'}
              label={
                project.is_ticketable
                  ? 'Wer sind die Organisatoren der Veranstaltung?'
                  : 'Die Macher: Wer ist alles in deinem Projekt involviert?'
              }
              initialValue={project.faq && project.faq[4]}
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <RichText
                name="hinter"
                getContent={this.setEditRichTextContent}
                placeholder="Antwort eingeben..."
              />
            </FormItem>

            <FormItem label="URL" name="url" initialValue={project.url}>
              <Input placeholder="URL" />
            </FormItem>

            {project.is_ticketable ? (
              <>
                <FormItem
                  label="Veranstaltungsdatum"
                  name="event_date"
                  initialValue={parseAdminDate(project.event_date)}
                  rules={eventDateRules}
                >
                  <DatePicker
                    format={ADMIN_DATE_FORMAT}
                    placeholder="Veranstaltungsdatum auswählen"
                    style={{ width: '100%' }}
                  />
                </FormItem>
                <FormItem
                  label="Buchungsschluss"
                  name="funding_end_date"
                  initialValue={parseAdminDate(project.funding_end_date)}
                  dependencies={['event_date']}
                  rules={bookingEndDateRules}
                >
                  <DatePicker
                    format={ADMIN_DATE_FORMAT}
                    placeholder="Buchungsschluss auswählen"
                    style={{ width: '100%' }}
                  />
                </FormItem>
              </>
            ) : (
              <FormItem
                label="Funding Goals"
                name="funding_days"
                initialValue={project.funding_days}
              >
                <Input placeholder="Funding Days" />
              </FormItem>
            )}

            <FormItem label="Goal" name="goal" initialValue={project.goal}>
              <Input placeholder="Goal" />
            </FormItem>

            <FormItem
              label="Final Goal"
              name="final_goal"
              initialValue={project.final_goal}
            >
              <Input placeholder="Final goal" />
            </FormItem>

            <FormItem
              name="category_ids"
              label="Kategorie deines Projekts"
              initialValue={project.category_ids}
            >
              <Select
                // defaultValue={this.def}
                showSearch
                value={value}
                tokenSeparators={[',']}
                placeholder="Wähle eine Kategorie"
                notFoundContent={
                  loading ? <Spin size="small" /> : <p>there is no result </p>
                }
                filterOption={false}
                onChange={this.handleChange}
                style={{ width: '100%' }}
                mode="multiple"
                dropdownStyle={{ zIndex: '2002' }}
              >
                {categories &&
                  categories?.map((category) => (
                    <Option
                      key={JSON.stringify(category)}
                      value={category.value}
                    >
                      {category.category}
                    </Option>
                  ))}
              </Select>
            </FormItem>

            <FormItem
              label="PayPal Status"
              name="paypal_check"
              initialValue={project?.paypal_check}
            >
              <Radio.Group defaultValue={project?.paypal_check}>
                <div className="paypal_account">
                  <Radio className="radio_buttons large" value={true}>
                    Ja
                  </Radio>
                  <Radio className="radio_buttons large" value={false}>
                    Nein
                  </Radio>
                </div>
              </Radio.Group>
            </FormItem>
            {/* <FormItem
              name="is_ticketable"
              valuePropName="checked"
              initialValue={project.is_ticketable}
            >
              <Checkbox>Ticket machen</Checkbox>
            </FormItem> */}

            <FormItem
              name="is_ticketable"
              initialValue={
                project?.is_ticketable
                  ? project?.is_ticketable
                  : !project?.is_patreon
                  ? null
                  : false
              }
            >
              <Radio.Group>
                <div className="paypal_account">
                  <Radio className="radio_buttons large" value={null}>
                    keiner
                  </Radio>
                  <Radio className="radio_buttons large" value={true}>
                    Ticket machen
                  </Radio>
                  <Radio className="radio_buttons large" value={false}>
                    Patreon
                  </Radio>
                </div>
              </Radio.Group>
            </FormItem>
            <FormItem
              label="PayPal Email"
              name="paypal_email"
              initialValue={project.paypal_email}
            >
              <Input placeholder="PayPal Email" />
            </FormItem>
            <FormItem
              label="Goal Explanation"
              name="goal_explanation"
              initialValue={project.goal_explanation}
            >
              <Input placeholder="Goal Explanation" />
            </FormItem>

            <FormItem label="City" name="city" initialValue={project.city}>
              <Input placeholder="City" />
            </FormItem>

            {/* <FormItem
              label="Message"
              name="message"
            >
              <Input placeholder="Message" defaultValue={project.message} />
            </FormItem> */}

            <FormItem
              label="Facebook URL"
              name="facebook_url"
              initialValue={project.facebook_url}
            >
              <Input placeholder="Facebook Url" />
            </FormItem>

            <FormItem
              label="Instagram URL"
              name="instagram_url"
              initialValue={project.instagram_url}
            >
              <Input placeholder="Instagram Url" />
            </FormItem>
            <FormItem
              label="Website URL"
              name="website_url"
              initialValue={project.website_url}
            >
              <Input placeholder="Website Url" />
            </FormItem>
            <FormItem
              label="Payout"
              name="pay_out"
              initialValue={project?.pay_out}
            >
              <Radio.Group>
                <div className="paypal_account">
                  <Radio className="radio_buttons large" value={true}>
                    Ja
                  </Radio>
                  <Radio className="radio_buttons large" value={false}>
                    Nein
                  </Radio>
                </div>
              </Radio.Group>
            </FormItem>
            <FormItem name="banner">
              <UploadImage
                required={false}
                multiple={false}
                label={'Banner'}
                // name={'banner'}
                setImage={this.setBannerImage}
                fileList={[
                  `${
                    project.banner &&
                    project.banner &&
                    project.banner.length > 0
                      ? project.banner
                      : null
                  }`,
                ]}
              />
            </FormItem>

            <FormItem name="outer_image">
              <UploadImage
                required={false}
                multiple={false}
                label={'Outer Image'}
                // name={'outer_image'}
                setImage={this.setOuterImage}
                fileList={[
                  `${
                    project.outer_image &&
                    project.outer_image &&
                    project.outer_image.length > 0
                      ? project.outer_image
                      : null
                  }`,
                ]}
              />
            </FormItem>

            <FormItem name="images[]">
              <UploadImage
                required={false}
                multiple={true}
                label={'images'}
                // name={'images[]'}
                setImage={this.setImages}
                fileList={
                  project.images && project.images && project.images.length > 0
                    ? project.images
                    : null
                }
              />
            </FormItem>

            {/* <FormItem
              label="tags"
              name="tags"
              // rules={[
              //   {
              //     required: true,
              //   },
              // ]}
            >
              <Input placeholder="tags" />
            </FormItem> */}

            <FormItem>
              <PrimaryButton type="primary" htmltype="submit" minWidth="150px">
                Update
              </PrimaryButton>
            </FormItem>
          </AdminEditForm>
        </Modal>
        <Modal
          showModal={showStartModal}
          handelCloseModal={this.handelCloseStartModal}
          width="880px"
        >
          <H2>Start Again</H2>
          <AdminEditForm
            ref={this.startFormRef}
            layout="vertical"
            onFinish={this.onStart}
          >
            <FormItem label="Title" name="title" initialValue={project.title}>
              <Input placeholder="Title" />
            </FormItem>

            <FormItem
              label="SubTile"
              name="subtitle"
              initialValue={project.subtitle}
            >
              <Input placeholder="SubTile" />
            </FormItem>

            <FormItem
              label="Description"
              name="description"
              initialValue={project.description}
            >
              <RichText
                name="description"
                getContent={this.setStartRichTextContent}
                placeholder="Description"
              />
            </FormItem>

            <FormItem
              name={'projekt'}
              label={
                project.is_ticketable
                  ? 'Was ist der Zweck der Veranstaltung?'
                  : 'Zweck: Was ist der genaue Zweck des Projektes?'
              }
              initialValue={project.faq && project.faq[0]}
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <RichText
                name="projekt"
                getContent={this.setStartRichTextContent}
                placeholder="Antwort eingeben..."
              />
            </FormItem>
            <FormItem
              name={'zielgruppe'}
              label={
                project.is_ticketable
                  ? 'Was sind die Ziele – und wer ist die Zielgruppe?'
                  : 'Ziele und Zielgruppe: Was sind die Ziele und wer ist die Zielgruppe?'
              }
              initialValue={project.faq && project.faq[1]}
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <RichText
                name="zielgruppe"
                getContent={this.setStartRichTextContent}
                placeholder="Antwort eingeben..."
              />
            </FormItem>
            {!project.is_ticketable && (
              <>
                <FormItem
                  name={'unterstützen'}
                  label="Wofür werden die Unterstützungen verwendet?"
                  initialValue={project.faq && project.faq[2]}
                  rules={[
                    {
                      required: false,
                    },
                  ]}
                >
                  <RichText
                    name="unterstützen"
                    getContent={this.setStartRichTextContent}
                    placeholder="Antwort eingeben..."
                  />
                </FormItem>
                <FormItem
                  name={'finanzierung'}
                  label="Wie sorgst du für Transparenz und einen verantwortungsvollen Umgang mit den Unterstützungen?"
                  initialValue={project.faq && project.faq[3]}
                  rules={[
                    {
                      required: false,
                    },
                  ]}
                >
                  <RichText
                    name="finanzierung"
                    getContent={this.setStartRichTextContent}
                    placeholder="Antwort eingeben..."
                  />
                </FormItem>
              </>
            )}
            <FormItem
              name={'hinter'}
              label={
                project.is_ticketable
                  ? 'Wer sind die Organisatoren der Veranstaltung?'
                  : 'Die Macher: Wer ist alles in deinem Projekt involviert?'
              }
              initialValue={project.faq && project.faq[4]}
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <RichText
                name="hinter"
                getContent={this.setStartRichTextContent}
                placeholder="Antwort eingeben..."
              />
            </FormItem>

            <FormItem label="URL" name="url" initialValue={project.url}>
              <Input placeholder="URL" />
            </FormItem>

            {project.is_ticketable ? (
              <>
                <FormItem
                  label="Veranstaltungsdatum"
                  name="event_date"
                  initialValue={parseAdminDate(project.event_date)}
                  rules={eventDateRules}
                >
                  <DatePicker
                    format={ADMIN_DATE_FORMAT}
                    placeholder="Veranstaltungsdatum auswählen"
                    style={{ width: '100%' }}
                  />
                </FormItem>
                <FormItem
                  label="Buchungsschluss"
                  name="funding_end_date"
                  initialValue={parseAdminDate(project.funding_end_date)}
                  dependencies={['event_date']}
                  rules={bookingEndDateRules}
                >
                  <DatePicker
                    format={ADMIN_DATE_FORMAT}
                    placeholder="Buchungsschluss auswählen"
                    style={{ width: '100%' }}
                  />
                </FormItem>
              </>
            ) : (
              <FormItem
                label="Funding Goals"
                name="funding_days"
                initialValue={project.funding_days}
              >
                <Input placeholder="Funding Days" />
              </FormItem>
            )}

            <FormItem label="Goal" name="goal" initialValue={project.goal}>
              <Input placeholder="Goal" />
            </FormItem>

            <FormItem
              label="Final Goal"
              name="final_goal"
              initialValue={project.final_goal}
            >
              <Input placeholder="Final goal" />
            </FormItem>
            <FormItem
              label="PayPal Status"
              name="paypal_check"
              initialValue={project.paypal_check}
            >
              <Radio.Group>
                <div className="paypal_account">
                  <Radio className="radio_buttons large" value={true}>
                    Ja
                  </Radio>
                  <Radio className="radio_buttons large" value={false}>
                    Nein
                  </Radio>
                </div>
              </Radio.Group>
            </FormItem>
            <FormItem
              label="PayPal Email"
              name="paypal_email"
              initialValue={project.paypal_email}
            >
              <Input placeholder="PayPal Email" />
            </FormItem>
            <FormItem
              label="Goal Explanation"
              name="goal_explanation"
              initialValue={project.goal_explanation}
            >
              <Input placeholder="Goal Explanation" />
            </FormItem>

            <FormItem label="City" name="city" initialValue={project.city}>
              <Input placeholder="City" />
            </FormItem>

            {/* <FormItem
              label="Message"
              name="message"
            >
              <Input placeholder="Message" defaultValue={project.message} />
            </FormItem> */}

            <FormItem
              label="Facebook URL"
              name="facebook_url"
              initialValue={project.facebook_url}
            >
              <Input placeholder="Facebook Url" />
            </FormItem>

            <FormItem
              label="Instagram URL"
              name="instagram_url"
              initialValue={project.instagram_url}
            >
              <Input placeholder="Instagram Url" />
            </FormItem>
            <FormItem
              label="Website URL"
              name="website_url"
              initialValue={project.website_url}
            >
              <Input placeholder="Website Url" />
            </FormItem>
            <FormItem name="banner">
              <UploadImage
                required={false}
                multiple={false}
                label={'Banner'}
                // name={'banner'}
                setImage={this.setBannerImage}
                fileList={[
                  `${
                    project.banner &&
                    project.banner &&
                    project.banner.length > 0
                      ? project.banner
                      : null
                  }`,
                ]}
              />
            </FormItem>

            <FormItem name="outer_image">
              <UploadImage
                required={false}
                multiple={false}
                label={'Outer Image'}
                // name={'outer_image'}
                setImage={this.setOuterImage}
                fileList={[
                  `${
                    project.outer_image &&
                    project.outer_image &&
                    project.outer_image.length > 0
                      ? project.outer_image
                      : null
                  }`,
                ]}
              />
            </FormItem>

            <FormItem name="images[]">
              <UploadImage
                required={false}
                multiple={true}
                label={'images'}
                // name={'images[]'}
                setImage={this.setImages}
                fileList={
                  project.images && project.images && project.images.length > 0
                    ? project.images
                    : null
                }
              />
            </FormItem>

            {/* <FormItem
              label="tags"
              name="tags"
              // rules={[
              //   {
              //     required: true,
              //   },
              // ]}
            >
              <Input placeholder="tags" />
            </FormItem> */}

            <FormItem>
              <PrimaryButton type="primary" htmltype="submit" minWidth="150px">
                Start
              </PrimaryButton>
            </FormItem>
          </AdminEditForm>
        </Modal>
        <Modal
          showModal={showConfirmDeleteFileModal}
          handelCloseModal={this.handelCloseConfirmDeleteFileModal}
        >
          <H2 style={{ textAlign: 'center', marginBottom: '30px' }}>
            Datei wirklich löschen?
          </H2>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <PrimaryButton
              className="warning"
              onClick={() => this.onDeleteFile()}
            >
              Löschen
            </PrimaryButton>
            <PrimaryButton
              onClick={() => this.handelCloseConfirmDeleteFileModal()}
            >
              Zurück
            </PrimaryButton>
          </div>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { project } = state.admin;
  const { categories, loading } = state.projects;

  return {
    project,
    categories,
    loading,
  };
};

const mapDispatchToProps = (dispatch) => ({
  showProjectById: (id) => dispatch(AdminActions.showProjectById(id)),
  declineProject: (id, message) =>
    dispatch(AdminActions.declineProject(id, message)),
  acceptProject: (id) => dispatch(AdminActions.acceptProject(id)),
  updateProject: (id, values) =>
    dispatch(AdminActions.updateProjectById(id, values)),
  startAgainProject: (id, values) =>
    dispatch(AdminActions.startProjectById(id, values)),
  getProjectCategories: () => dispatch(ProjectsActions.getProjectCategories()),
  hideProject: (id) => dispatch(AdminActions.hideProject(id)),
  closeJob: (id) => dispatch(AdminActions.closeJob(id)),
  recurringJob: (id) => dispatch(AdminActions.recurringJob(id)),
  checkMark: (id) => dispatch(AdminActions.checkMark(id)),
  projectPaypalToggleHandler: (id) =>
    dispatch(AdminActions.asyncProjectPaypalToggleHandler(id)),
  projectToggleAnonymousHandler: (id) =>
    dispatch(AdminActions.asyncProjectToggleAnonymousHandler(id)),
  deleteFile: (id, fileId) => dispatch(AdminActions.deleteFile(id, fileId)),
});
export default connect(mapStateToProps, mapDispatchToProps)(ViewProject);
